import http from '@/utils/services/http'

export default {
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/leiloes/' + id) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  findSimple (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/leiloes/' + id + '/simple') // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  lista (limit, page, filtros) {
    let url = '/api/leiloes?page=' + page + '&limit=' + limit + filtros
    console.log(url)
    return http.get(url) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  buscaCategorias () {
    return http.get('/api/leiloes/categorias')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  buscaComitentes () {
    return http.get('/api/comitentes/simple')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  buscaTipos () {
    return http.get('/api/leiloes/cadastro/tipos')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  cadastro (leilao, id) {
    if (typeof id !== 'undefined') {
      return this.atualizacao(leilao, id)
    }
    return http.post('/api/leiloes', leilao)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacao (data, id) {
    return http.patch('/api/leiloes/' + id, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  uploadArquivosLeilao (leilao, formData) {
    return http.post('/api/leiloes/' + leilao + '/arquivosPreCadastro', formData, {headers: {'Content-Type': 'multipart/form-data'}}) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  atualizaStatusLeilao (id, status) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/leiloes/' + id + '/status/' + status)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  uploadDocumentoLeilao (leilao, nome, file) {
    return http.post('/api/leiloes/' + leilao + '/documento', file, {headers: {'Content-Type': 'multipart/form-data'}}) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteDocumentoLeilao (leilao, id) {
    return http.delete('/api/leiloes/' + leilao + '/documento/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  // Lote
  findLote (leilaoId, id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/leiloes/' + leilaoId + '/lotes/' + id) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  setFotoDestaque (leilao, lote, id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.post('/api/leiloes/' + leilao + '/lotes/' + lote + '/updateFotoDestaque/' + id) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  uploadFotoLote (leilao, lote, foto) {
    return http.post('/api/leiloes/' + leilao + '/lotes/' + lote + '/uploadFoto', foto, {headers: {'Content-Type': 'multipart/form-data'}}) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteFotoLote (leilao, lote, foto) {
    return http.delete('/api/leiloes/' + leilao + '/lotes/' + lote + '/foto/' + foto)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizaDestaque (leilao, lote, value) {
    return http.post('/api/leiloes/' + leilao + '/lotes/' + lote + '/destaque', {destaque: value})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizaStatusLote (leilao, lote, status) {
    return http.post('/api/leiloes/' + leilao + '/lotes/' + lote + '/status/' + status)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getLoteLances (leilao, lote) {
    return http.get('/api/leiloes/' + leilao + '/lotes/' + lote + '/lances')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getLeilaoLances (leilao, lote) {
    let extra = typeof lote !== 'undefined' ? '?lote=' + parseInt(lote) : ''
    return http.get('/api/leiloes/' + leilao + '/lances' + extra)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteLance (id, motivo) {
    return http.delete('/api/lance/' + id, {params: {motivo: motivo}})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteAllLances (id, motivo) {
    return http.delete('/api/zerar-lance/' + id, {params: {motivo: motivo}})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  desistenciaLote (id, motivo) {
    return http.delete('/api/desistencia-lote/' + id, {params: {motivo: motivo}})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  carregaDesistenciasLote (id) {
    return http.get('/api/lista-desistencia-lote/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  carregaDesistenciasArrematante (id) {
    return http.get('/api/lista-desistencia-arrematante/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  gerarEmailDesistencia (id) {
    return http.get(`/api/desistencia/${id}/comunicador/getCobrancaDesistencia`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  enviarEmailDesistencia (id, data) {
    return http.post(`/api/desistencia/${id}/comunicador/sendCobrancaDesistencia`, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  gerarEmailInformeNegativacao (id) {
    return http.get(`/api/desistencia/${id}/comunicador/getInformeNegativacao`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  enviarEmailInformeNegativacao (id, data) {
    return http.post(`/api/desistencia/${id}/comunicador/sendInformeNegativacao`, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  gerarEmailRegistroNegativacao (id) {
    return http.get(`/api/desistencia/${id}/comunicador/getRegistroNegativacao`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  enviarEmailRegistroNegativacao (id, data) {
    return http.post(`/api/desistencia/${id}/comunicador/sendRegistroNegativacao`, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  buscaTiposBem () {
    return http.get('/api/tipobem')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  buscaCamposTiposBem (tipoBemId) {
    return http.get('/api/tipobem/' + tipoBemId + '/campos')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  buscaMarcas (tipoBemId) {
    return http.get('/api/tipobem/' + tipoBemId + '/marcas')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  buscaModelos (marcaId) {
    return http.get('/api/marca/' + marcaId + '/modelos')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  cadastroLote (lote, id) {
    if (typeof id !== 'undefined') {
      return this.atualizacaoLote(lote, id)
    }
    return http.post('/api/lotes', lote)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacaoLote (data, id) {
    return http.patch('/api/lotes/' + id, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  pendenciasComitenteMonitor (id) {
    return http.get('/api/pregao/pendenciasComitenteMonitor/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  pendenciasVoltarLoteMonitor (id) {
    return http.get('/api/pregao/pendenciasVoltarLoteMonitor/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  pendenciasVoltarLoteComitentes (id) {
    return http.get('/api/pregao/pendenciasVoltarLoteComitentes/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  pendenciasVoltarLoteComitentesAlterar (id, data) {
    return http.post('/api/pregao/pendenciasVoltarLoteComitentesAlterar/' + id, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  aceitaVoltarLoteMonitor (id) {
    return http.post('/api/pregao/pendenciasVoltarLoteMonitor/' + id + '/aceitar')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  pendenciasVendasOnline (id) {
    return http.get('/api/pregao/pendenciasVendasOnline/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  excluirLotes (leilao, lotes) {
    return http.post('/api/leiloes/' + leilao + '/excluirLotes', lotes)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  copiarLote (leilao, novoLeilao, lote) {
    return http.post('/api/leiloes/' + leilao + '/' + novoLeilao + '/copiarLote', {id: lote})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  relatorioSaida (leilao) {
    return http.get('/api/leiloes/' + leilao + '/relatorios/saida')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  relatorioSaidaArrematante (leilao) {
    return http.get('/api/leiloes/' + leilao + '/relatorios/saidaArrematante')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  renovaCache (leilao) {
    return http.put('/api/leiloes/' + leilao + '/cache/renovar')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  importar (data, cbUploadProgress) {
    return http.post('/api/leiloes/importar', data, {
      headers: {'Content-Type': 'multipart/form-data'},
      onUploadProgress: cbUploadProgress
    })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  importarProcessar (file) {
    return http.put('/api/leiloes/importar', {file: file})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  importarLeilao (importador, dados) {
    return http.post('/api/leiloes/importarLeilao?importador=' + importador, dados)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  importarLote (importador, dados, renovar) {
    let url = '/api/leiloes/importarLote?importador=' + importador
    if (typeof renovar !== 'undefined' && renovar) {
      url = url + '&try=1'
    }
    return http.post(url, dados, {'timeout': 300000})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch((response) => {
        return Promise.reject(response)
      })
  },
  gerarCobranca (leilao, lote) {
    return http.get('/api/leiloes/' + leilao + '/' + lote + '/gerarCobrancaView')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  enviarEmailComunicacaoLote (lote, dados) {
    return http.post('/api/lote/comunicador/send', dados)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  checaComunicacaoLote (leilao) {
    return http.get(`/api/leilao/${leilao}/comunicador/check`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  checaLeiloesAbertos () {
    return http.get(`/api/leilao/check/abertos`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  enviaAvisosComunicacao (lote) {
    /* console.log(`Enviando lote ${lote}`)
    return new Promise(resolve => setTimeout(resolve, 3000)) */
    return http.post(`/api/lote/${lote}/comunicador/sendIndividual`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  updateVideoDestaque (lote, video) {
    return http.post(`/api/lote/${lote}/videoDestaque`, {video: video})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  updateUrlVideoComitente (url) {
    return http.post(`/api/comitente/updateVideoUrl`, {url: url})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteAprovacaoComitente (lote) {
    return http.delete(`/api/comitente/deleteAprovacao/${lote}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getLeilaoResumo (leilao) {
    return http.get('/api/leiloes/' + leilao + '/relatorio/resumo')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getLeilaoFechamento (leilao) {
    return http.get('/api/leiloes/' + leilao + '/relatorio/fechamento')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  iniciaSincronizacaoLocal (leilao, config) {
    return http.post('/api/leiloes/' + leilao + '/initSyncLocal')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  alterarValorLance (lanceId, novoValor) {
    return http.patch(`/api/leiloes/alterar-lance/${lanceId}`, {novovalor: novoValor})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  updateLinkLive (leilaoId, url) { /* raphael */
    return http.patch(`/api/leiloes/${leilaoId}/update-live`, {url})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  sincronizaErp (leilao) {
    return http.post(`/api/leiloes/${leilao}/sincronizaErp`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/leiloes/services/index.js